import Box from "@mui/material/Box";
import type { FC } from "react";

const RACKS = 6;
const RACK_WIDTH = 22;
const BASE_HEIGHT = 56;
const HERO_GRADIENT = "linear-gradient(135deg, #10103A 0%, #1F00FF 140%)";

/**
 * Figma D13 showcase hero: a row of translucent racks on the deep-blue gradient. Decorative; the real
 * preview is the Builder 3D tour.
 */
export const RackIllustration: FC<{ height?: number }> = ({ height = 150 }) => (
	<Box
		aria-hidden
		sx={{
			height,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			gap: 1,
			background: HERO_GRADIENT
		}}>
		{Array.from({ length: RACKS }, (_, index) => (
			<Box
				key={index}
				sx={{
					width: RACK_WIDTH,
					height: BASE_HEIGHT + (index % 2) * 6,
					borderRadius: "2px",
					border: "1px solid rgba(255,255,255,0.45)",
					bgcolor: `rgba(138,174,255,${0.25 + index * 0.08})`
				}}
			/>
		))}
	</Box>
);
